import React from 'react';
import { useTranslation } from 'react-multi-lang';
import { useDispatch } from 'react-redux';
import { showClientSlice } from '../../containers/Clients/ShowModal/ShowModalSlice';

import { showMaterialSlice } from '../../containers/Materials/ShowModal/ShowModalSlice';

import { showProductSlice } from '../../containers/Pricing/ShowModal/ShowModalSlice';
import { showServiceSlice } from '../../containers/Services/ShowModal/ShowModalSlice';
import { showSupplierSlice } from '../../containers/Suppliers/ShowModal/ShowModalSlice';
import { EllipsisLoader } from '../Loader/Loader';
import Modal from '../Modal/Modal';

import './DetailsModal.css';
import { attribute } from '../../containers/Services/ShowModal/ShowModal';

interface DetailsModalProps {
  isOpen: boolean;
  toggle: Function;
  isLoading?: boolean;
  title?: string;
  reports?: any;
  actions?: any;
  attributes?: attribute[];
  product_attributes?: {
    name: string;
    value: string;
  }[];
  data: {
    [key: string]: any;
  };
}

const  DetailsModal= (props: DetailsModalProps) => {
  // Redux
  const dispatch = useDispatch();

  // Translation
  const t = useTranslation();
  return (
    <Modal open={props.isOpen} toggle={props.toggle}>
      {props.isLoading ? (
        <div className="center">
          <EllipsisLoader />
        </div>
      ) : (
        <>
          {props.title ? (
            <h3 className="details-modal-title">{props.title}</h3>
          ) : (
            ''
          )}
          <table className="details-table">
            {Object.keys(props.data).map((key, index) => (
              <>
                {props.data[key] === null ? (
                  ''
                ) : (
                  <tr key={key}>
                    <td>{t(key)}</td>
                    <td>
                      {typeof props.data[key] === 'object' ? (
                        props.data[key].type === 'client' ? (
                          <div className="tags">
                            <li
                              className="tag"
                              onClick={() =>
                                dispatch(
                                  showClientSlice.actions.setIsOpen({
                                    id: props.data[key].data.id,
                                    isOpen: true,
                                  }),
                                )
                              }>
                              {props.data[key].data.name}
                            
                            </li>
                          </div>
                        ) : props.data[key].type === 'order' ? (
                          <div className="tags">
                            <li
                              className="tag"
                              onClick={() =>{}
                                // dispatch(
                                //   // showOrderSlice.actions.setIsOpen({
                                //   //   id: props.data[key].data.id,
                                //   //   isOpen: true,
                                //   // }),
                                // )
                              }>
                              {props.data[key].data.order_no}
                             
                            </li>
                          </div>
                        ) : props.data[key].type === 'products' ? (
                          <div className="tags">
                            {props.data[key].data.map((product: any) => (
                              <li
                                className="tag"
                                onClick={() =>
                                  dispatch(
                                    showProductSlice.actions.setIsOpen({
                                      id: product.id,
                                      isOpen: true,
                                    }),
                                  )
                                }>
                                {product.name + ` (${product.amount})`}
                            
                              </li>
                            ))}
                          </div>
                        ) : key === 'materials' ? (
                          <div className="tags">
                            {props.data[key].map((material: any) => (
                              <li
                                className="tag"
                                onClick={() =>
                                  dispatch(
                                    showMaterialSlice.actions.setIsOpen({
                                      id: material.id,
                                      isOpen: true,
                                      product_attributes: material.attributes,
                                    }),
                                  )
                                }>
                                {material.name +
                                  ` (${material.amount})` +
                                  (material.price
                                    ? ` - price: ${material.price}`
                                    : '')}
                              </li>
                            ))}
                          </div>
                        ) : key === 'services' ? (
                          <div className="tags">
                            {props.data[key].map((service: any) => (
                              <li
                                className="tag"
                                onClick={() =>
                                  dispatch(
                                    showServiceSlice.actions.setIsOpen({
                                      id: service.id,
                                      isOpen: true,
                                      product_attributes: service.attributes,
                                    }),
                                  )
                                }>
                                {service.name}
                              </li>
                            ))}
                          </div>
                        ) : key === 'supplier' ? (
                          <div className="tags">
                            <li
                              className="tag"
                              onClick={() =>
                                dispatch(
                                  showSupplierSlice.actions.setIsOpen({
                                    id: props.data[key].id,
                                    isOpen: true,
                                  }),
                                )
                              }>
                              {props.data[key].name}
                            </li>
                          </div>
                        ) : (
                          <ul>
                            {props.data[key].map(
                              (item: string, index: number) => (
                                <li key={index}>{item}</li>
                              ),
                            )}
                          </ul>
                        )
                      ) : (
                        props.data[key]
                      )}
                    </td>
                  </tr>
                )}
              </>
            ))}
            {props.reports ? (
              <tr>
                <td>{t('reports')}</td>
                <td>{props.reports}</td>
              </tr>
            ) : null}
            {props.actions ? (
              <tr>
                <td>{t('actions')}</td>
                <td>{props.actions}</td>
              </tr>
            ) : null}
          </table>
          {props.attributes && props.attributes.length > 0 ? (
            <>
              <h3 className="details-modal-title" style={{ marginTop: 30 }}>
                {t('attributes')}
              </h3>
              <table
                className="details-table"
                style={props.product_attributes ? {} : { width: 800 }}>
                <tbody>
                  {props.product_attributes ? (
                    <>
                      {props.product_attributes.map((attribute) => (
                        <tr>
                          <td>{attribute.name}</td>
                          <td>{attribute.value}</td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <>
                      {props.attributes.map((attribute) => (
                        <tr>
                          <td>{attribute.name}</td>
                          <td>{t(attribute.type || '')}</td>
                          <td colSpan={attribute.type === 'String' ? 6 : 2}>
                            <span className="label">Hint:</span>{' '}
                            {attribute.hint}
                          </td>
                          {attribute.type === 'Pre-defined' ? (
                            <td colSpan={4}>
                              <span className="label">Values:</span>{' '}
                              {attribute.items
                                ?.map((item: any) => item.name)
                                .join(', ')}
                            </td>
                          ) : attribute.type === 'Number' ? (
                            <>
                              <td colSpan={2}>
                                <span className="label">Min:</span>{' '}
                                {attribute.min}
                              </td>
                              <td colSpan={2}>
                                <span className="label">Max:</span>{' '}
                                {attribute.max}
                              </td>
                            </>
                          ) : (
                            ''
                          )}
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
            </>
          ) : (
            ''
          )}
        </>
      )}
    </Modal>
  );
};
export default DetailsModal ;